var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#34544F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 14.5h-2.4c-1 0-1.7.6-1.7 1.6v2.5c0 1 .6 1.7 1.7 1.7h2.4c1.1 0 1.7-.6 1.7-1.7v-2.5c0-1-.6-1.6-1.7-1.6Zm.2 2.7-.3.2c-.2 0-.3 0-.4-.2l-.2-.1v1.8c0 .3-.2.6-.5.6a.5.5 0 0 1-.5-.6v-1.8l-.2.1c-.2.2-.5.2-.7 0a.5.5 0 0 1 0-.7l1-1 .2-.2h.4l.2.1 1 1c.2.3.2.6 0 .8ZM13.7 22.6v4.1c0 2 1.5 3.5 3.4 3.5H27c1.9 0 3.4-1.6 3.4-3.5v-4.1c0-.6-.4-1-1-1H14.7a1 1 0 0 0-1 1Zm5 4.8H17a.6.6 0 0 1-.6-.6c0-.4.3-.7.6-.7h1.7c.3 0 .6.3.6.7 0 .3-.3.6-.6.6Zm5.4 0h-3.4a.6.6 0 0 1-.6-.6c0-.4.3-.7.6-.7h3.4c.3 0 .6.3.6.7 0 .3-.3.6-.6.6ZM23.2 16.8v2.5c0 .5-.4 1-1 1h-7.5a1 1 0 0 1-1-1 3.5 3.5 0 0 1 3.4-3.5h5.1c.6 0 1 .5 1 1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.7498f297501370a673d600e8f7d45022.svg";
export { ForwardRef as ReactComponent };